// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const plankStack = defineModel({
  id: "plank-stack",
  batchId: "future",
  name: "Plank stack",
  tags: ["scenery","plank","stack","low-poly","age-of-mcp","future"],
  summary: "A stack of sawn planks — the everyday building and crafting timber.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [-0.012, 0.015, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [0.012, 0.045, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [-0.012, 0.075, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [0.012, 0.105, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [-0.012, 0.135, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [0.012, 0.165, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [-0.012, 0.195, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.18), color: "#caa56a", position: [0.012, 0.225, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.03, 0.5), color: "#bd9658", position: [-0.08, 0.255, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.03, 0.5), color: "#caa56a", position: [0.1, 0.285, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.2), color: "#7a5a36", position: [0.16, 0.13, 0] },
    ],
  animations: [],
});
